import { render, staticRenderFns } from "./IFEfficiencyVariance.vue?vue&type=template&id=6645718c"
import script from "./IFEfficiencyVariance.vue?vue&type=script&lang=js"
export * from "./IFEfficiencyVariance.vue?vue&type=script&lang=js"
import style0 from "./IFEfficiencyVariance.vue?vue&type=style&index=0&id=6645718c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports